import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { IconButtonModule } from '@core/buttons/icon-button/icon-button.module';
import { CalendarAvailabilityModule } from '@core/calendar-availability/calendar-availability.module';
import { TimeFormatModule } from '@core/time-format/time-format.module';
import { TranslatePipe } from '@ngx-translate/core';
import { SendAnalyticsModule } from '../analytics/send-analytics/send-analytics.module';
import { DialogAvailabilityComponent } from './dialog-availability/dialog-availability.component';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';
import { SafeHtmlModule } from '../safe-html/safe-html.module';
import { getAnimationModule } from '@core/animation/animation';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    TranslatePipe,
    IconButtonModule,
    CalendarAvailabilityModule,
    TimeFormatModule,
    SendAnalyticsModule,
    SafeHtmlModule,
    SendAnalyticsModule,
    getAnimationModule()
  ],
  declarations: [DialogConfirmComponent, DialogAvailabilityComponent],
  exports: []
})
export class DialogModule {}
